module.exports = __webpack_public_path__ + "static/media/koss-portapro.0ac7a34f.jpg";